<template>
  <div class="policyList">
    <div class="policyList-nav">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
        background-color="#BD1A2D"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu
          v-for="(item, index) in treeData"
          :key="index"
          :index="item.nodeId + ''"
        >
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>{{ item.nodeName }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(child, childIndex) in item.items"
              :key="childIndex"
              :index="child.nodeId + ''"
              >{{ child.nodeName }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class="policyList-list">
      <cus-title text="政策文件"></cus-title>
      <ul>
        <li v-for="(item, index) in policyList" :key="index" @click="toDetails(item)">
          <div>
            <span></span>
            <span class="spanText" v-html="showKeyWord(item.fileName,searchValue)"></span>
            
          </div>
          <div>{{ item.releaseDate }}</div>
        </li>
      </ul>
      <div class="pagination-box" v-if="total">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          background
          :page-size="10"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findPolicySortTreeList,
  findCheckedPolicyFilePage,
} from "@/api/policy";
export default {
  data() {
    return {
      policyList: [],
      pageNo: 1,
      pageSize: 10,
      total: null,
      treeData: [],
      defaultActive: "101",
      searchValue:'',
      fileSort:"",
    };
  },
  mounted() {
    this.searchValue = this.$route.query.searchValue
    this.fileSort = this.$route.query.fileSort
    if(this.fileSort){
      this.defaultActive = this.fileSort
    }
    this.findPolicySortTreeList();
    this.findCheckedPolicyFilePage(this.defaultActive);
  },
  methods: {
    async findPolicySortTreeList() {
      const res = await findPolicySortTreeList();
      console.log(res);
      this.treeData = res.data.listData;
    },
    async findCheckedPolicyFilePage(fileSort) {
      const res = await findCheckedPolicyFilePage({
        pageNo: this.pageNo,
        pageSize: 10,
        fileSort,
      });
      this.policyList = res.data.listData.content;
      this.total = res.data.listData.totalElements
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key);
      console.log(keyPath);
      this.defaultActive = key
      this.findCheckedPolicyFilePage(key);
    },

    handleCurrentChange(val) {
      this.pageNo = val;
      this.findCheckedPolicyFilePage(this.defaultActive);
      //this.findCheckedPolicyFilePage()
    },
    toDetails(item){
      let routeData = this.$router.resolve({
        path: "/policyDetails",
        query: {
          keyId: item.policyFileId,
        },
      });
      window.open(routeData.href, '_blank')
    },
  },
};
</script>

<style lang="less" scoped>
.pagination-box {
    display: flex;
    justify-content: center;  // 将翻页器居中
    margin-top: 300px;
  }
.policyList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: space-between;
  .policyList-nav {
    width: 237px;
  }
  .policyList-list {
    flex: 1;
    margin-left: 27px;
    > ul {
      margin-top: 30px;
      > li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        cursor: pointer;
        > div:nth-child(1) {
          display: flex;
          align-items: center;
          font-size: 19px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #262626;
          line-height: 24px;
          > span {
            &:nth-child(1) {
              width: 8px;
              height: 8px;
              background: #333333;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
        > div:nth-child(2) {
          font-size: 21px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #aeaeae;
          line-height: 21px;
        }
      }
    }
  }
}
/deep/ .el-submenu .el-menu-item {
  background: #fff !important;
  color: #262626 !important;
}
.el-menu-item.is-active {
  background: #eee !important;
}
/deep/ .el-menu-item-group__title {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/policy/policyList.vue